const directives: Record<string, string[]> = {
  'default-src': ["'self'", '*.vanguard.com:*', '*.vgcontent.info:*', '*.kampyle.com'],
  'script-src': [
    "'self'",
    '*.vanguard.com:*',
    '*.vgcontent.info:*',
    '*.demdex.net',
    'fls.doubleclick.net',
    '*.fls.doubleclick.net',
    'vanguard.d2.sc.omtrdc.net',
    "'unsafe-eval'",
    '*.omniture.com',
    'activitymap.adobe.com',
    '*.vgdynamic.info',
    '*.kampyle.com',
    "'unsafe-inline'",
    '*.tt.omtrdc.net',
    // duping everywhere
    '*.onetrust.com',
    '*.adsymptotic.com',
    '*.linkedin.com',
    '*.adsrvr.org',
    '*.analytics.yahoo.com',
    '*.amazon-adsystem.com',
    '*.omtrdc.net',
    '*.doubleclick.net',
    '*.googleapis.com',
    '*.gstatic.com',
    '*.medallia.com',
    'www.google.com',
    'cdn.cookielaw.org',
    '*.mypurecloud.com',
    'wss://*.mypurecloud.com',
  ],
  'style-src': [
    "'self'",
    '*.vanguard.com:*',
    '*.vgcontent.info:*',
    '*.kampyle.com',
    "'unsafe-inline'",
    //here
    '*.tt.omtrdc.net',
    '*.onetrust.com',
    '*.adsymptotic.com',
    '*.linkedin.com',
    '*.adsrvr.org',
    '*.analytics.yahoo.com',
    '*.amazon-adsystem.com',
    '*.omtrdc.net',
    '*.doubleclick.net',
    '*.googleapis.com',
    '*.gstatic.com',
    '*.medallia.com',
    'www.google.com',
    'cdn.cookielaw.org',
    '*.mypurecloud.com',
    'wss://*.mypurecloud.com',
  ],
  'connect-src': [
    "'self'",
    '*.vanguard.com:*',
    '*.vgcontent.info:*',
    '*.demdex.net',
    'fls.doubleclick.net',
    '*.fls.doubleclick.net',
    'vanguard.d2.sc.omtrdc.net',
    '*.eum-appdynamics.com',
    '*.kampyle.com',
    '*.medallia.com',
    '*.tt.omtrdc.net',
    'privacyportal-de.onetrust.com',
    'geolocation.onetrust.com',
    'cdn.cookielaw.org',
    //here
    '*.onetrust.com',
    '*.adsymptotic.com',
    '*.linkedin.com',
    '*.adsrvr.org',
    '*.analytics.yahoo.com',
    '*.amazon-adsystem.com',
    '*.doubleclick.net',
    '*.googleapis.com',
    '*.gstatic.com',
    'www.google.com',
    '*.mypurecloud.com',
    'wss://*.mypurecloud.com',
  ],
  'img-src': [
    "'self'",
    '*.vanguard.com:*',
    '*.vgcontent.info:*',
    '*.demdex.net',
    'fls.doubleclick.net',
    '*.fls.doubleclick.net',
    'vanguard.d2.sc.omtrdc.net',
    '*.eum-appdynamics.com',
    't.myvisualiq.net',
    'data:',
    '*.vgdynamic.info',
    '*.kampyle.com',
    '*.facebook.com',
    '*.amazon-adsystem.com',
    '*.analytics.yahoo.com',
    'insight.adsrvr.org',
    '*.ads.linkedin.com',
    'p.adsymptotic.com',
    //here
    '*.onetrust.com',
    '*.adsymptotic.com',
    '*.linkedin.com',
    '*.adsrvr.org',
    '*.omtrdc.net',
    '*.doubleclick.net',
    '*.googleapis.com',
    '*.gstatic.com',
    '*.medallia.com',
    'www.google.com',
    'cdn.cookielaw.org',
    '*.mypurecloud.com',
    'wss://*.mypurecloud.com',
  ],
  'frame-src': [
    "'self'",
    '*.vanguard.com:*',
    '*.vgcontent.info:*',
    '*.demdex.net',
    'fls.doubleclick.net',
    '*.fls.doubleclick.net',
    'vanguard.d2.sc.omtrdc.net',
    '*.omniture.com',
    'activitymap.adobe.com',
    '*.kampyle.com',
    'insight.adsrvr.org',
    //here
    '*.onetrust.com',
    '*.adsymptotic.com',
    '*.linkedin.com',
    '*.adsrvr.org',
    '*.analytics.yahoo.com',
    '*.amazon-adsystem.com',
    '*.omtrdc.net',
    '*.doubleclick.net',
    '*.googleapis.com',
    '*.gstatic.com',
    '*.medallia.com',
    'www.google.com',
    'cdn.cookielaw.org',
    '*.mypurecloud.com',
    'wss://*.mypurecloud.com',
  ],
  'object-src': ["'self'", '*.vanguard.com:*', '*.vgcontent.info:*'],
};

const script_policies: string = directives['script-src'].join(' ');
const img_policies: string = directives['img-src'].join(' ');
const style_policies: string = directives['style-src'].join(' ');
const connect_policies: string = directives['connect-src'].join(' ');

const frames_policies: string = directives['frame-src'].join(' ');

const object_policies: string = directives['object-src'].join(' ');

export interface CSP {
  readonly 'img-src': string;
  readonly 'script-src': string;
  readonly 'style-src': string;
  readonly 'connect-src': string;
  readonly 'frame-src': string;
  readonly 'object-src': string;
}

export const csp: CSP = {
  'img-src': img_policies,
  'script-src': script_policies,
  'style-src': style_policies,
  'connect-src': connect_policies,
  'frame-src': frames_policies,
  'object-src': object_policies,
};
